import { useAtomValue } from 'jotai'

import { invoiceAttachmentsAtom } from 'Invoices/atoms/invoiceEditing.atom'
import { AttachmentsCarousel } from 'Assets/Attachments'
import { Section } from '../components'

export const Attachments = () => {
  const attachments = useAtomValue(invoiceAttachmentsAtom)

  if (!attachments.length) return null

  return (
    <Section title="Attachments" data-testid="invoice.attachments">
      <AttachmentsCarousel
        attachments={attachments}
        testIdPrefix="invoice.attachments"
      />
    </Section>
  )
}
